import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './religion.reducer';

export const Religion = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const religionList = useAppSelector(state => state.religion.entities);
  const loading = useAppSelector(state => state.religion.loading);
  const totalItems = useAppSelector(state => state.religion.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="religion-heading" data-cy="ReligionHeading">
        <Translate contentKey="apiLocationApp.religion.home.title">Religions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="apiLocationApp.religion.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/religion/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="apiLocationApp.religion.home.createLabel">Create new Religion</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {religionList && religionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="apiLocationApp.religion.id">ID</Translate> <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('geographicLevel')}>
                  <Translate contentKey="apiLocationApp.religion.geographicLevel">Geographic Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('geographicLevel')} />
                </th>
                <th className="hand" onClick={sort('date')}>
                  <Translate contentKey="apiLocationApp.religion.date">Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('date')} />
                </th>
                <th className="hand" onClick={sort('geography')}>
                  <Translate contentKey="apiLocationApp.religion.geography">Geography</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('geography')} />
                </th>
                <th className="hand" onClick={sort('geographyCode')}>
                  <Translate contentKey="apiLocationApp.religion.geographyCode">Geography Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('geographyCode')} />
                </th>
                <th className="hand" onClick={sort('totalAllUsualResidents')}>
                  <Translate contentKey="apiLocationApp.religion.totalAllUsualResidents">Total All Usual Residents</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalAllUsualResidents')} />
                </th>
                <th className="hand" onClick={sort('christian')}>
                  <Translate contentKey="apiLocationApp.religion.christian">Christian</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('christian')} />
                </th>
                <th className="hand" onClick={sort('buddhist')}>
                  <Translate contentKey="apiLocationApp.religion.buddhist">Buddhist</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('buddhist')} />
                </th>
                <th className="hand" onClick={sort('hindu')}>
                  <Translate contentKey="apiLocationApp.religion.hindu">Hindu</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hindu')} />
                </th>
                <th className="hand" onClick={sort('jewish')}>
                  <Translate contentKey="apiLocationApp.religion.jewish">Jewish</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('jewish')} />
                </th>
                <th className="hand" onClick={sort('muslim')}>
                  <Translate contentKey="apiLocationApp.religion.muslim">Muslim</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('muslim')} />
                </th>
                <th className="hand" onClick={sort('sikh')}>
                  <Translate contentKey="apiLocationApp.religion.sikh">Sikh</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sikh')} />
                </th>
                <th className="hand" onClick={sort('otherReligion')}>
                  <Translate contentKey="apiLocationApp.religion.otherReligion">Other Religion</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('otherReligion')} />
                </th>
                <th className="hand" onClick={sort('noReligion')}>
                  <Translate contentKey="apiLocationApp.religion.noReligion">No Religion</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('noReligion')} />
                </th>
                <th className="hand" onClick={sort('religionNotStated')}>
                  <Translate contentKey="apiLocationApp.religion.religionNotStated">Religion Not Stated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('religionNotStated')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {religionList.map((religion, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/religion/${religion.id}`} color="link" size="sm">
                      {religion.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`apiLocationApp.GeographicLevel.${religion.geographicLevel}`} />
                  </td>
                  <td>{religion.date}</td>
                  <td>{religion.geography}</td>
                  <td>{religion.geographyCode}</td>
                  <td>{religion.totalAllUsualResidents}</td>
                  <td>{religion.christian}</td>
                  <td>{religion.buddhist}</td>
                  <td>{religion.hindu}</td>
                  <td>{religion.jewish}</td>
                  <td>{religion.muslim}</td>
                  <td>{religion.sikh}</td>
                  <td>{religion.otherReligion}</td>
                  <td>{religion.noReligion}</td>
                  <td>{religion.religionNotStated}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/religion/${religion.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/religion/${religion.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/religion/${religion.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="apiLocationApp.religion.home.notFound">No Religions found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={religionList && religionList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Religion;
